import { http } from "./http";

/**
 * Histórico, checkpoints e restauração das versões do projeto.
 * Todo commit é validado no backend: pertence sempre ao projeto atual.
 */

const BASE_URL = import.meta.env.VITE_API_URL ?? "/api";

export interface VersionItem {
  uuid: string;
  number: number;
  description: string;
  source: string;
  git_commit: string | null;
  author: string | null;
  created_at: string | null;
  stats?: Record<string, unknown> | null;
}

export interface VersionFile {
  status: string;
  path: string;
}

export interface VersionDetail extends VersionItem {
  files: VersionFile[];
}

export interface RestoreResult {
  uuid: string;
  number: number;
  restored_from: number;
  rebuild: "queued" | "skipped";
}

/** Rótulo amigável da origem da versão. */
export function sourceLabel(source: string): string {
  return (
    {
      ai: "Inteligência artificial",
      user: "Manual",
      system: "Automático",
      restore: "Restauração",
    }[source] ?? source
  );
}

/** Rótulo do tipo de alteração de arquivo no commit. */
export function fileStatusLabel(status: string): string {
  const key = status.charAt(0).toUpperCase();
  return { A: "criado", M: "alterado", D: "excluído", R: "renomeado" }[key] ?? status;
}

export const versionService = {
  list: (project: string) => http.get<VersionItem[]>(`/projects/${project}/versions`),
  show: (project: string, version: string) =>
    http.get<VersionDetail>(`/projects/${project}/versions/${version}`),
  diff: (project: string, version: string) =>
    http.get<{ diff: string }>(`/projects/${project}/versions/${version}/diff`),
  restore: (project: string, version: string) =>
    http.post<RestoreResult>(`/projects/${project}/versions/${version}/restore`, {}),
  checkpoint: (project: string, description: string) =>
    http.post<VersionItem>(`/projects/${project}/versions`, { description }),
  downloadUrl: (project: string, version: string) =>
    `${BASE_URL}/projects/${project}/versions/${version}/download`,
};
